import {Directive, ElementRef, Input, Renderer2} from '@angular/core';

@Directive({
  selector: '[dkYetkiKontrol]',
  standalone: true,
})
export class YetkiKontrolDirective {
  @Input('dkYetkiKontrol') yetkiler: string[]; // Yetki listesi girişi

  constructor(private elementRef: ElementRef, private renderer: Renderer2) { }

  ngOnInit() {
    // Kullanıcının yetkilerini kontrol et
    if (this.yetkiler && this.yetkiler.length > 0) {
      // Burada gerçek kullanıcı yetkilerini almalısınız

      // Butonun veya elemanın yetkisine göre görünürlüğünü ayarla
      if (!this.kullaniciYetkisiVar(this.yetkiler)) {
        this.renderer.setStyle(this.elementRef.nativeElement, 'display', 'none'); // Yetki yoksa elemanı gizle
      }
    }
  }

  private kullaniciYetkisiVar(yetkiler: string[]): boolean {
    // Kullanıcının belirli bir yetkiye sahip olup olmadığını kontrol et
    return yetkiler.some(yetki => this.yetkiler.includes(yetki));
  }
}
